// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9910 ? "a4634e51" : chunkId) + "." + {"301":"31a4ee60f5dc8a99","393":"ea80e8b3d0fc1238","1257":"50c169a728538d07","3623":"afdf173e65688c5f","4046":"8bd64f222dafb001","4543":"37e81df5ebbc7fbb","6483":"d0838765279e42d7","8768":"3f85c9976d28bd86","9910":"1f11e9a81dca31fe"}[chunkId] + ".js";
};